import "./style.css";
import { t } from "../../services/formatters";
import { TextInput } from "../TextInput";
import { useSession } from "../../hooks/useSession";
import { isName, isEmail, isPhone, isCap } from "../../services/validators";
import { useState } from "react";

export const FormDatiUtenteC5 = ({ title = "", lockFields = false, nome = "", cognome = "" }) => {
  const { read, update } = useSession();

  const [nameState, setNameState] = useState(isName(read("nome")) ? 3 : 1);
  const [surnameState, setSurnameState] = useState(isName(read("cognome")) ? 3 : 1);
  const [emailState, setEmailState] = useState(isEmail(read("email")) ? 3 : 1);
  const [phoneState, setPhoneState] = useState(isPhone(read("cellulare")) ? 3 : 1);
  const [capState, setCapState] = useState(isCap(read("cap_utente")) ? 3 : 1);

  return (
    <div className={`section white-box input-box-component full-form`}>
      <h2>{title}</h2>
      <p className="crea-appto-error full-form-appto-error hidden">Tutti i campi vanno compilati correttamente.</p>
      <p className={`input-box-subtitle`}>&nbsp;</p>
      <TextInput
        state={nameState}
        name="nome"
        readonly={lockFields}
        placeholder={t("name")}
        value={nome || read("nome")}
        onChange={(value) => {
          setNameState(1);
          update("nome", value);
        }}
        onBlur={(value) => {
          isName(value) ? setNameState(3) : setNameState(4);
        }}></TextInput>
      <TextInput
        state={surnameState}
        name="cognome"
        readonly={lockFields}
        placeholder={t("surname")}
        value={cognome || read("cognome")}
        onChange={(value) => {
          setSurnameState(1);
          update("cognome", value);
        }}
        onBlur={(value) => {
          isName(value) ? setSurnameState(3) : setSurnameState(4);
        }}></TextInput>
      <TextInput
        state={emailState}
        type="email"
        name="email"
        placeholder={t("email")}
        value={read("email")}
        onChange={(value) => {
          setEmailState(1);
          update("email", value);
        }}
        onBlur={(value) => {
          isEmail(value) ? setEmailState(3) : setEmailState(4);
        }}></TextInput>
      <TextInput
        state={phoneState}
        name="cellulare"
        placeholder={t("tel")}
        value={read("cellulare")}
        onChange={(value) => {
          setPhoneState(1);
          update("cellulare", value);
        }}
        onBlur={(value) => {
          isPhone(value) ? setPhoneState(3) : setPhoneState(4);
        }}></TextInput>
      <TextInput
        state={capState}
        name="cap_utente"
        placeholder={t("cap")}
        value={read("cap_utente")}
        onChange={(value) => {
          setCapState(1);
          update("cap_utente", value);
        }}
        onBlur={(value) => {
          isCap(value) ? setCapState(3) : setCapState(4);
        }}></TextInput>
    </div>
  );
};
